export default {
  // Header Section
  "discover_your": "உங்கள்",
  "numerology": "எண்ணியல்",
  "numbers_reveal_destiny": "எண்கள் உங்கள் விதியை வெளிப்படுத்தும்",
  "numerology_description": "உங்கள் வாழ்க்கையில் எண்களின் மாய சக்தியைத் திறந்து, வாழ்க்கைப் பாதை, விதி எண், தன்மை பண்புகள், மேலும் உங்கள் பயணத்தை வடிவமைக்கும் தெய்வீக எண் அதிர்வுகள் ஆகியவற்றை உள்ளடக்கிய முழுமையான எண்ணியல் பகுப்பாய்வைப் பெறுங்கள்.",

  // Service Information
  "enter_details_for_numerology": "எண்ணியலுக்கான உங்கள் விவரங்களை உள்ளிடுங்கள்",
  "complete_numerology_analysis": "முழுமையான எண்ணியல் பகுப்பாய்வு",
  "service_price": "சேவை விலை",
  "comprehensive_numerology_analysis_note": "உங்கள் எண் வரைபடத்தை ஆழமாக ஆய்ந்து, உங்கள் வாழ்க்கையின் தெய்வீக கணித வடிவங்களை அறிந்து கொள்ளுங்கள்",

  // Form Fields
  "full_name": "முழுப் பெயர்",
  "enter_full_name": "உங்கள் முழுப் பெயரை உள்ளிடுங்கள்",
  "name_vibration_analysis": "உங்கள் பெயர் குறிப்பிட்ட எண் அதிர்வுகளைத் தாங்கி, உங்கள் விதியைப் பாதிக்கிறது",
  "email_address": "மின்னஞ்சல் முகவரி",
  "enter_email_address": "உங்கள் மின்னஞ்சல் முகவரியை உள்ளிடுங்கள்",
  "phone_number": "தொலைபேசி எண்",
  "enter_phone_number": "உங்கள் தொலைபேசி எண்ணை உள்ளிடுங்கள்",
  "gender": "பாலினம்",
  "male": "ஆண்",
  "female": "பெண்",
  "other": "மற்றவை",
  "date_of_birth": "பிறந்த தேதி",
  "birth_date_life_path_number": "உங்கள் பிறந்த தேதி உங்கள் வாழ்க்கைப் பாதை எண்ணையும் மைய நோக்கத்தையும் வெளிப்படுத்துகிறது",
  "preferred_language": "விருப்ப மொழி",
  "english": "ஆங்கிலம்",
  "hindi": "ஹிந்தி",
  "telugu": "தெலுங்கு",
  "kannada": "கன்னடம்",
  "language_note": "உங்கள் எண்ணியல் பகுப்பாய்வு தேர்ந்தெடுத்த மொழியில் வழங்கப்படும்",

  // Core Numerology Features
  "life_path_number_analysis": "வாழ்க்கைப் பாதை எண் பகுப்பாய்வு",
  "destiny_number_insights": "விதி எண் நுண்ணறிவுகள்",
  "personality_number_traits": "தன்மை எண் பண்புகள்",
  "lucky_numbers_and_colors": "அதிர்ஷ்ட எண்கள் & நிறங்கள்",
  "career_compatibility_numbers": "தொழில் இணக்க எண்கள்",
  "pdf_download": "முழுமையான PDF அறிக்கை",

  "what_you_get": "உங்கள் எண்ணியல் பகுப்பாய்வில் உள்ளவை",
  "complete_numerology_chart": "முழு எண்ணியல் வரைபடம்",
  "core_numbers_analysis": "மைய எண்களின் பகுப்பாய்வு",
  "personal_year_predictions": "தனிப்பட்ட ஆண்டு முன்னறிவிப்பு",
  "compatibility_insights": "எண் இணக்க வழிகாட்டி",

  // Actions & Buttons
  "pay_and_generate_analysis": "என் எண்ணியல் பகுப்பாய்வை பெறவும்",
  "processing_payment": "கட்டணம் செயலாக்கப்படுகிறது",
  "processing_request": "பகுப்பாய்வு உருவாக்கப்படுகிறது",

  // Payment & Success Messages
  "thank_you": "நன்றி",
  "payment_successful": "கட்டணம் வெற்றிகரமாக முடிந்தது!",
  "numerology_analysis_processing": "உங்கள் எண்ணியல் பகுப்பாய்வை எங்கள் நிபுணர்கள் கணக்கிடுகின்றனர். உங்கள் எண் வரைபடத்திற்கான விரிவான நுண்ணறிவுகள் வழங்கப்படும்.",
  "order_id": "ஆர்டர் ஐடி",
  "payment_id": "கட்டணம் ஐடி",
  "amount_paid": "செலுத்திய தொகை",

  // Delivery Information
  "delivery_information": "விநியோக தகவல்",
  "delivery_time": "பகுப்பாய்வு விநியோகம்",
  "within_12_hours_delivery_note": "உங்கள் விரிவான எண்ணியல் அறிக்கை 12 மணிநேரத்திற்குள் தயார் ஆகும்",
  "whatsapp_notification": "WhatsApp புதுப்பிப்புகள்",
  "whatsapp_delivery_note": "WhatsApp-ல் உடனடி அறிவிப்புகள் பெறுங்கள்",
  "email_delivery": "மின்னஞ்சல் விநியோகம்",
  "email_delivery_note": "முழு பகுப்பாய்வு அனுப்பப்படும் முகவரி",

  // What You'll Receive
  "what_youll_receive": "உங்கள் எண்ணியல் பகுப்பாய்வு தொகுப்பு",
  "detailed_numerology_report": "முழுமையான எண்ணியல் அறிக்கை (PDF)",
  "life_path_destiny_analysis": "வாழ்க்கைப் பாதை & விதி எண் பகுப்பாய்வு",
  "personal_numbers_meanings": "தனிப்பட்ட எண்கள் & அவற்றின் அர்த்தங்கள்",
  "lucky_elements_guidance": "அதிர்ஷ்ட கூறுகள் & வழிகாட்டுதல்",
  "annual_forecast_insights": "வருடாந்திர எண்ணியல் முன்னறிவிப்பு",

  // Visual Content
  "sample_numerology_analysis": "மாதிரி எண்ணியல் பகுப்பாய்வு",
  "life_path_number": "வாழ்க்கைப் பாதை எண்",
  "sample_life_path_description": "தேடுபவர் — பகுப்பாய்வுத் திறன், ஆன்மீக மனம், உள்நோக்க பார்வை",
  "sample_numerology_description": "உங்கள் தனிப்பயன் எண்ணியல் பகுப்பாய்வின் முன்னோட்டம் — விரிவான நுண்ணறிவுகளுடன்",
  "core_numbers": "மைய எண்கள்",

  // Core Number Types
  "life_path": "வாழ்க்கைப் பாதை",
  "destiny": "விதி",
  "personality": "தன்மை",
  "soul_urge": "ஆத்தும ஆசை",
  "birthday": "பிறந்தநாள்",
  "maturity": "மெச்ச நிலை",

  // Status & Processing
  "your_numerology_analysis_status": "உங்கள் எண்ணியல் பகுப்பாய்வு நிலை",
  "processing_your_analysis": "உங்கள் எண்கள் கணக்கிடப்படுகின்றன",
  "analysis_processing_message": "உங்கள் எண் முறைமைகள் ஆய்வு செய்யப்படுகின்றன; தனிப்பயன் நுண்ணறிவுகள் தயாராகின்றன.",
  "request_id": "பகுப்பாய்வு ஐடி",
  "status": "நிலை",
  "processing": "நடைபெறுகிறது",
  "pending": "வரிசையில் உள்ளது",
  "email_notification_sent": "உறுதிப்படுத்தும் மின்னஞ்சல் அனுப்பப்பட்டது",
  "whatsapp_update_coming": "WhatsApp புதுப்பிப்புகள் இயலுமைப்படுத்தப்பட்டுள்ளன",
  "delivery_within_12_hours": "அறிக்கை 12 மணிநேரத்தில் தயார்",

  // Support & Contact
  "contact_support": "எண்ணியல் ஆதரவைத் தொடர்புகொள்ளுங்கள்",
  "need_help": "வழிகாட்டல் வேண்டுமா?",
  "contact_us_at": "எங்களை அணுக",

  // Error Messages
  "please_fill_all_required_fields": "தேவையான அனைத்து விவரங்களையும் பூர்த்தி செய்யுங்கள்",
  "payment_failed": "கட்டணம் தோல்வியடைந்தது. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
  "processing_failed": "பகுப்பாய்வு செயலாக்கம் தோல்வியடைந்தது. எங்கள் ஆதரவுடன் தொடர்புகொள்ளுங்கள்.",

  // Core Numerology Numbers
  "life_path_number": "வாழ்க்கைப் பாதை எண்",
  "destiny_number": "விதி எண்",
  "personality_number": "தன்மை எண்",
  "soul_urge_number": "ஆத்தும ஆசை எண்",
  "birthday_number": "பிறந்தநாள் எண்",
  "maturity_number": "மெச்ச நிலை எண்",
  "expression_number": "வெளிப்பாடு எண்",
  "heart_desire_number": "இதய ஆசை எண்",

  // Number Meanings (1-9)
  "number_1_meaning": "தலைமை, சுய்நிலைத்தன்மை, முன்னோடி",
  "number_2_meaning": "இணக்கம், கூட்டாண்மை, தூதரகம்",
  "number_3_meaning": "படைப்பாற்றல், வெளிப்பாடு, தொடர்பாடல்",
  "number_4_meaning": "நிலைத்தன்மை, கடின உழைப்பு, அடித்தளம்",
  "number_5_meaning": "சுதந்திரம், சாகசம், மாற்றம்",
  "number_6_meaning": "பரிவு, பொறுப்பு, சிகிச்சை மனம்",
  "number_7_meaning": "ஆன்மீகம், பகுப்பாய்வு, ஞானம்",
  "number_8_meaning": "பொருளாதார வெற்றி, அதிகாரம், சாதனை",
  "number_9_meaning": "மனிதநேயம், நிறைவு, சேவை",

  // Master Numbers
  "master_number_11": "மாஸ்டர் எண் 11 — உள்ளுணர்வு & உள்ளூக்கம்",
  "master_number_22": "மாஸ்டர் எண் 22 — மாஸ்டர் பில்டர்",
  "master_number_33": "மாஸ்டர் எண் 33 — மாஸ்டர் ஆசான்",

  // Personality & Character Analysis
  "core_personality_traits": "மைய தன்மை பண்புகள்",
  "strengths_and_talents": "இயல்பான வலிமைகள் & திறமைகள்",
  "challenges_to_overcome": "மீற வேண்டிய சவால்கள்",
  "life_lessons": "முக்கிய வாழ்க்கைப் பாடங்கள்",
  "inner_motivation": "உள் உந்துதல்",
  "outer_expression": "மற்றவர்கள் உங்களை எப்படிப் பார்க்கின்றனர்",

  // Life Path Analysis
  "life_purpose": "வாழ்க்கை நோக்கம் & பணி",
  "career_guidance": "தொழில் வழிகாட்டுதல்",
  "relationship_patterns": "உறவு முறைபாடுகள்",
  "financial_tendencies": "பணம் & நிதி சார்ந்த முன்னிலை",
  "health_insights": "ஆரோக்கிய & நல நுண்ணறிவுகள்",
  "spiritual_journey": "ஆன்மீக வளர்ச்சி பாதை",

  // Compatibility Analysis
  "love_compatibility": "உங்கள் காதல் வாழ்க்கை",
  "friendship_compatibility": "நட்பு இணக்கம்",
  "business_compatibility": "வணிக கூட்டாண்மை இணக்கம்",
  "family_dynamics": "குடும்ப உறவு இயக்கவியல்",
  "compatible_numbers": "மிகச் சிறந்த இணக்க எண்கள்",
  "challenging_numbers": "சவாலாக இருக்கக் கூடிய எண்கள்",

  // Lucky Elements
  "lucky_numbers": "தனிப்பட்ட அதிர்ஷ்ட எண்கள்",
  "lucky_colors": "அதிர்ஷ்ட நிறங்கள்",
  "lucky_days": "அதிர்ஷ்ட நாட்கள்",
  "lucky_gemstones": "ஆசியளிக்கும் ரத்தினங்கள்",
  "lucky_directions": "அதிர்ஷ்ட திசைகள்",
  "lucky_metals": "அதிர்ஷ்ட உலோகங்கள்",

  // Personal Year Analysis
  "current_personal_year": "தற்போதைய தனிப்பட்ட ஆண்டு",
  "personal_year_theme": "ஆண்டின் தீம் & கவனம்",
  "monthly_guidance": "மாதந்தோறும் வழிகாட்டுதல்",
  "opportunities_this_year": "இந்த ஆண்டின் முக்கிய வாய்ப்புகள்",
  "challenges_this_year": "இவ்வாண்டின் சவால்கள்",
  "recommendations_this_year": "இவ்வாண்டுக்கான குறிப்புகள்",

  // Name Analysis
  "name_numerology": "பெயர் எண்ணியல் பகுப்பாய்வு",
  "first_name_vibration": "முதல் பெயர் அதிர்வு",
  "last_name_influence": "குடிப் பெயர் தாக்கம்",
  "full_name_power": "முழுப் பெயரின் சக்தி",
  "nickname_effects": "அடைப்பெயர் தாக்கங்கள்",
  "name_change_suggestions": "பெயர் மேம்பாட்டு பரிந்துரைகள்",

  // Birth Date Analysis
  "birth_date_significance": "பிறந்த தேதியின் முக்கியத்துவம்",
  "day_vibration": "நாள் எண் தாக்கம்",
  "month_influence": "பிறந்த மாதத் தாக்கம்",
  "year_energy": "பிறந்த ஆண்டின் ஆற்றல்",
  "complete_birth_pattern": "முழுமையான பிறப்பு வடிவப் பகுப்பாய்வு",

  // Karmic Numbers
  "karmic_debt_numbers": "கர்ம கடன் எண்கள்",
  "karmic_lessons": "கர்ம வாழ்க்கைப் பாடங்கள்",
  "soul_contracts": "ஆத்தும ஒப்பந்தங்கள் & உடன்படிக்கைகள்",
  "past_life_influences": "முன் பிறவி எண் தாக்கங்கள்",

  // Cycles & Periods
  "life_cycles": "முக்கிய வாழ்க்கைச் சுழற்சிகள்",
  "pinnacle_numbers": "பின்னாக்கல் (Pinnacle) கால எண்கள்",
  "challenge_numbers": "சவால் கால எண்கள்",
  "personal_months": "தனிப்பட்ட மாதச் சுழற்சிகள்",

  // Advanced Analysis
  "master_numbers_significance": "உங்கள் வரைபடத்தில் மாஸ்டர் எண்களின் பங்கு",
  "missing_numbers": "இல்லாத எண்கள் பகுப்பாய்வு",
  "repeated_numbers": "மீண்டும் மீண்டும் தோன்றும் எண்கள் — அர்த்தம்",
  "intensity_table": "எண் தீவிரத்தன்மை பகுப்பாய்வு",

  // Practical Applications
  "best_dates_for_decisions": "முக்கிய முடிவுகளுக்கான சிறந்த தேதிகள்",
  "timing_for_ventures": "புதிய முயற்சிகளுக்கான உகந்த காலம்",
  "home_address_analysis": "வீட்டு முகவரி எண்ணியல்",
  "phone_number_analysis": "தொலைபேசி எண் அதிர்வுகள்",
  "choosing_baby_names": "குழந்தை பெயர் எண்ணியல் வழிகாட்டுதல்",

  // Remedies & Recommendations
  "numerical_remedies": "எண்ணியல் பரிகாரங்கள்",
  "color_therapy": "நிற சிகிச்சை பரிந்துரைகள்",
  "gemstone_suggestions": "ரத்தின பரிந்துரைகள்",
  "mantras_for_numbers": "எண்களுக்கு ஏற்ற மந்திரங்கள்",
  "meditation_techniques": "எண்ணியல் தியான முறைகள்",

  // Business & Career
  "business_name_analysis": "வணிகப் பெயர் எண்ணியல்",
  "career_number_alignment": "தொழில்-எண் ஒத்திசைவு",
  "partnership_numbers": "வணிக கூட்டாண்மை எண்கள்",
  "investment_timing": "முதலீட்டு நேர வழிகாட்டுதல்",
  "product_launch_dates": "தயாரிப்பு வெளியீட்டு தேதி தேர்வு"
};
